import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaStar,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaBullhorn,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const HighQualityPromotionalVideosInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="High-Quality Promotional Videos in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Amplify Your Brand</Subheading>}
        heading={
          <Heading>
            High-Quality <span tw="text-primary-500">Promotional Videos</span>{" "}
            in DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we create high-quality promotional videos in
            **DIFC** that captivate audiences and drive engagement. Our expertly
            crafted videos amplify your brand’s message and leave a lasting
            impression.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1601506521937-0b4218f2e801?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Film production setup
          "https://images.unsplash.com/photo-1540655037529-dec987208707?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Creative lighting effects
          "https://images.unsplash.com/photo-1580983218765-f663bec07b37?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Professional camera equipment
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Create Your Video"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Promotional Videos in DIFC"
        description="We produce promotional videos with creativity and impact."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Stunning Visuals",
            description: "Cinematic quality that grabs attention.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Proven Expertise",
            description: "Trusted by DIFC’s top brands.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Engaging Storytelling",
            description: "Compelling narratives that resonate.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Quick Turnaround",
            description: "Fast delivery with flawless results.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Platform Optimized",
            description: "Videos tailored for social media and web.",
          },
          {
            icon: <FaBullhorn color="#ff5464" size={40} />,
            title: "Marketing Focus",
            description: "Designed to boost brand visibility.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Promotional Video Process"
        description={
          <Description>
            We craft high-quality promotional videos with a streamlined process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your marketing goals.</li>
              <li>Scripting: Develop engaging storylines.</li>
              <li>Filming: Capture with state-of-the-art equipment.</li>
              <li>Editing: Enhance visuals and audio for impact.</li>
              <li>Delivery: Provide polished videos ready to launch.</li>
              <li>Support: Offer ongoing assistance and updates.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Team collaboration
          "https://images.unsplash.com/photo-1610374792793-f016b77ca51a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Studio production setup
          "https://images.unsplash.com/photo-1536240478700-b869070f9279?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Artistic video composition
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Promotional Video Wins in DIFC"
        description="Our videos have driven success for DIFC businesses."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Viral Campaigns",
            description: "Boosted engagement with dynamic promos.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Brand Exposure",
            description: "Increased visibility for DIFC clients.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "96% approval from promotional projects.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for High-Quality Videos?</Subheading>}
        heading="Promotional Videos in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset for high-quality promotional videos in
            DIFC. Create captivating, impactful content that elevates your
            brand—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1536240478700-b869070f9279?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Video editing workspace
          "https://images.unsplash.com/photo-1546412414-e1885259563a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Dubai skyline
          "https://images.unsplash.com/photo-1523207911345-32501502db22?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Professional camera equipment
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
